<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Daftar</strong> Peserta Diklat Guru </h1>
            <div>
              Modul ini digunakan untuk melihat Daftar Peserta Diklat Guru Sekolah Penggerak
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <statistik :value="statistik"></statistik>-->
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          btn-download
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Peserta</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter ref="filter" title="Pilih Filter Status" :filtered="filtered" @save="filterSave" />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 my-3">
                          <div class="black--text subtitle-2">
                            {{ $getDeepObj(item, 'ptk.data.nama') || '-' }}
                          </div>
                          <div class="caption">
                            <span>
                              <v-icon small left>mdi-label-outline</v-icon>
                              {{ $getDeepObj(item, 'ptk.data.no_ukg') || $getDeepObj(item, 'ptk_id') || '-' }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Sekolah</span>
                          <p class="ma-0">
                            <span>{{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Mata Pelajaran</span>
                          <p class="ma-0">
                            <span>{{ $getDeepObj(item, 'm_mapel_psp.data.keterangan') || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Instansi yang menyetujui</span>
                          <p class="ma-0">
                            <span>
                              {{ $getDeepObj(item, 'psp_diklat_sekolahs.data.0.instansi_p4tk.data.nama') || '-' }}
                            </span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
export default {
  name: 'Index',
  mixins: [list],
  data() {
    return {
      listLaporan: [
        {
          key: 'download-guru-balai',
          label: `Laporan Daftar Peserta Diklat`,
        },
      ],
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      diklat: (state) => (state.data && state.data.diklat) || {},
    }),
  },
  methods: {
    ...mapActions('diklatPeserta', ['balai', 'downloadList']),
    ...mapActions('master', ['getMasters']),

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params);
        const attr = Object.assign({}, this.attr);
        this.balai({ params, attr }).then(({ data, meta }) => {
          this.data = data || [];
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          resolve(true);
        });
      });
    },

    downloadLaporan(url) {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      this.downloadList({ params, url: url.dokumen }).then((url) => {
        this.$downloadFile(url);
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
